module.exports = __webpack_public_path__ + "static/media/ft_memo.acc2eb63.png";